export const SET_APPLICATION_SESSION = 'setApplicationSession'
export const SET_APPLICATION_SESSION_PENDING_REQUEST = 'setApplicationSessionPendingRequests'
